<template>
  <div>
    <van-nav-bar
        left-arrow
        title="我的订单"
        @click-left="$router.push({name: 'userCenter'});"
        left-text="">
    </van-nav-bar>
    <div style="padding-top: 50px" class="wxMyOrderss">
      <div>
        <van-tabs v-model="active" @click="onClickTab">
          <van-tab title="待服务"></van-tab>
          <van-tab title="已服务"></van-tab>
        </van-tabs>
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <div
              v-for="item in list"
              :key="item.id">
            <div
                class="van-doc-demo-block__title_k"
                @click="goInfo(item.ordersn)">
              <van-row>
                <van-col span="15">
                  <div style="text-align: left;">下单时间：{{ item.createTime }}</div>
                </van-col>
                <van-col span="9">
                  <div style="text-align: right;color:red">状态：{{ types(item.orderFlag) }}</div>
                </van-col>
              </van-row>
            </div>
            <van-card
                :title="item.prodName"
                :thumb="$getFileAccessHttpUrl(item.prodPic)"
                @click="goInfo(item.ordersn)"
            >
              <template #num>
                共:{{ item.prodCount }}件
              </template>
              <template #price>
                <span style="font-weight: normal;font-size: 10pt">
                  {{ item.typeFlag === 0 ? ('爱心:' + item.amount) : ('¥ ' + item.amount) }}[查看]
                </span>
              </template>
            </van-card>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import {
  NavBar, Divider,
  Button, Field, Tab, Tabs,
  List, Card
} from 'vant'
import {postAction} from '@/api/manage'

export default {
  components: {
    [Button.name]: Button, [Divider.name]: Divider,
    [List.name]: List, [Tab.name]: Tab, [Tabs.name]: Tabs,
    [Field.name]: Field, [NavBar.name]: NavBar, [Card.name]: Card,
  },

  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: false,
      pageNumber: 1,
      balanceLast: 0,
      urls: 'balanceList',
      kyz: this,
      orderFlag: 20,
    }
  },
  mounted() {
  },
  methods: {
    onLoad() {
      this.loadData()
    },
    onClickTab(name) {
      if (name === 0) {
        this.refreshData(20)
      } else {
        this.refreshData(40)
      }
    },
    goInfo(ordersn) {
      this.$router.push({name: 'account/myOrderInfo', query: {ordersn: ordersn}});
    },
    refreshData(orderFlag) {
      this.loading = false
      this.finished = false
      this.pageNumber = 1
      this.list = []
      this.orderFlag = orderFlag
    },
    types(tt) {
      if (tt == 0) {
        return '待付款'
      } else if (tt == 20) {
        return '待服务'
      } else if (tt == 40) {
        return '已服务'
      } else if (tt == 100) {
        return '已取消'
      }
    },
    loadData() {
      const that = this
      //发送 post 请求
      this.$nextTick(() => {
        postAction('/web/api/order/getMyOrderList', {
          pageNo: that.pageNumber,
          orderFlag: this.orderFlag
        }).then(function (response) {
          console.log(response.result)
          // 异步更新数据
          for (let i = 0; i < 10; i++) {
            if (response.result.data.records[i]) {
              that.list.push(response.result.data.records[i])
            }
          }
          that.pageNumber = that.pageNumber + 1
          // 加载状态结束
          that.loading = false
          // 数据全部加载完成
          if (that.list.length >= response.result.data.total) {
            that.finished = true
          }
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.van-card__bottom {
  padding-bottom: 20px;
}

.van-card__desc {
  margin-top: 6px;
}

.van-card__title {
  font-size: 11pt;
}

.wxMyOrderss .van-card__price {
  font-size: 13pt !important;
}

.wxMyOrderss .van-card__price-integer {
  font-size: 13pt !important;
}

.van-nav-bar {
  position: fixed;
  width: 100%;
}
.wxMyOrderss .van-card__bottom {
  padding-bottom: 10px!important;
}
.van-doc-demo-block__title_k {
  margin: 0;
  padding: 7px 14px 0px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 12px;
  background-color: white;
  margin-bottom: -10px;
  margin-top: 10px;
}

</style>
